<div class="breadcrumbs">
  <span class="title">Lista DPGR<mat-icon style="vertical-align: middle;">keyboard_arrow_right
    </mat-icon> Lista DPGR </span>
</div>
<hr>
<div class="titolo flex-display">
  <span class="h1 upp">Lista DPGR</span>
</div>

<mat-expansion-panel class='rett' hideToggle (opened)="arrowFlag = !arrowFlag" (closed)='arrowFlag = !arrowFlag'>
  <mat-expansion-panel-header class="colorSearch">
    <mat-panel-title class='search'>
      <mat-icon>search</mat-icon>
      <strong class="title">CERCA</strong>
      <mat-icon *ngIf="arrowFlag">keyboard_arrow_up</mat-icon>
      <mat-icon *ngIf="!arrowFlag">keyboard_arrow_down</mat-icon>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="coloredS" [formGroup]="form">
    <div class="flex-row">
      <mat-form-field appearance="fill" color='accent' class='searchbar'>
        <mat-label>DPGR</mat-label>
        <input matInput [formControlName]="'dpgr'">
      </mat-form-field>

      <mat-form-field appearance="fill" color='accent' class='searchbar'>
        <mat-label for="descrizione">Denominazione</mat-label>
        <input matInput [formControlName]="'descrizione'">
      </mat-form-field>

      <mat-form-field appearance="fill" color='accent' class='searchbar'>
        <mat-label>Stato</mat-label>
        <mat-select [formControlName]="'stato'">
          <mat-option value=''></mat-option>
          <mat-option value='BOZ'> In bozza </mat-option>
          <mat-option value='RAC'> Raccolta Dati </mat-option>
          <mat-option value='ATT'> In attesa di emergenza </mat-option>
          <mat-option value='POS'> Post Emergenza </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="flex-row">
      <mat-form-field appearance="fill" color='accent' class='searchbar'>
        <mat-label>OCDPC</mat-label>
        <input [formControlName]="'ocdpc'" matInput>
      </mat-form-field>

      <mat-form-field appearance="fill" color='accent' class='searchbar'>
        <mat-label>Data DPGR da:</mat-label>
        <input matInput [matDatepicker]="picker1" [formControlName]="'dataEventoDa'" class='searchbar'>
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill" color='accent' class='searchbar'>
        <mat-label>Data DPGR a:</mat-label>
        <input matInput [matDatepicker]="picker2" [formControlName]="'dataEventoA'" class='searchbar'>
        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
      </mat-form-field>
    </div>
  </div>
  <mat-action-row class='colored'>
    <button mat-stroked-button class="pers2" color="warn" (click)="onReset()">Reset</button>
    <button mat-raised-button class="pers2" color="accent" (click)="ricercaListaSegnalazioni()">Cerca</button>
  </mat-action-row>
</mat-expansion-panel>


<mat-table [dataSource]="dataSource" matSort matSortActive="idEvento" matSortDirection="asc" matSortDisableClear>

  <ng-container matColumnDef="dpgr">
    <mat-header-cell *matHeaderCellDef mat-sort-header> DPGR </mat-header-cell>
    <mat-cell [attr.data-label]="'DPGR'" *matCellDef="let element">
      {{element.dpgr}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="denominazione">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Denominazione </mat-header-cell>
    <mat-cell [attr.data-label]="'DENOMINAZIONE'" *matCellDef="let element"> {{element.denominazione}} </mat-cell>
  </ng-container>

  <!-- <ng-container matColumnDef="ente" >
  <mat-header-cell *matHeaderCellDef mat-sort-header> Ente </mat-header-cell>
  <mat-cell [attr.data-label]="'ENTE'" *matCellDef="let element"> {{showEnteTab(element.idEnte)}} </mat-cell>
</ng-container> -->

  <ng-container matColumnDef="stato">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Stato </mat-header-cell>
    <mat-cell [attr.data-label]="'STATO'" *matCellDef="let element">
      <span *ngIf="element.stato == 'BOZ'">In bozza</span>
      <span *ngIf="element.stato == 'RAC'">Raccolta Dati</span>
      <span *ngIf="element.stato == 'ATT'">In attesa di emergenza</span>
      <span *ngIf="element.stato == 'POS'">Post Emergenza</span>
      <span *ngIf="element.stato == 'RDP'">Raccolta Dati</span>
      <span *ngIf="element.stato == 'ENR'">Emergenza non riconosciuta</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="ocdpc">
    <mat-header-cell *matHeaderCellDef mat-sort-header> OCDPC </mat-header-cell>
    <mat-cell [attr.data-label]="'OCDPC'" *matCellDef="let element"> {{element.ocdpc}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="dataEvento">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Data DPGR </mat-header-cell>
    <mat-cell [attr.data-label]="'DATA DPGR:'" *matCellDef="let element"> {{element.dataEvento | date: 'dd/MM/yyyy'}}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="primaDataChiusuraRaccolta">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Data chiusura </mat-header-cell>
    <mat-cell [attr.data-label]="'DATA CHIUSURA:'" *matCellDef="let element"> {{element.primaDataChiusuraRaccolta |
      date: 'dd/MM/yyyy'}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="inviato">
    <mat-header-cell *matHeaderCellDef mat-sort-header [hidden]="acl == 'dgpe' || acl == 'dpcpl'"> Inviato
    </mat-header-cell>
    <mat-cell [attr.data-label]="'INVIATO'" *matCellDef="let element" [hidden]="acl == 'dgpe' || acl == 'dpcpl'">
      <span *ngIf="element.inviato == 'S'">Sì</span>
      <span *ngIf="element.inviato == 'N'">No</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef> Azioni </mat-header-cell>
    <mat-cell *matCellDef="let element">
      <span *ngIf="element.idEvento !== openToggle" class="material-icons" title="apri/chiudi toolbar"
        (click)="openToggle = element.idEvento">more_horiz</span>

      <myp-toolbar *ngIf="element.idEvento === openToggle" [toolbar]="toolbar" role=toolbar [data]="element"
        [data]="element" (onToolbarEvent)="handleToolbarEvent($event)">
      </myp-toolbar>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns "></mat-header-row>
  <mat-row *matRowDef="let row; columns:displayedColumns"></mat-row>

</mat-table>

<div *ngIf="this.dataSource.counter$.source['value'] === 0">
  <mat-card class="emptyTable">
    <mat-card-content>
      <h6>Non ci sono risultati</h6>
    </mat-card-content>
  </mat-card>
</div>

<mat-paginator style="flex-wrap: wrap;" id='paginator' [pageSize]="risultatiPerPagina"
  [pageSizeOptions]="[3, 5, 10, 100, 300]"></mat-paginator>
